import React, { useEffect } from 'react'
import "./ReusableComponentCss.css"

function SelectPligramComponents({ mainHeading, data, setSelectedPligrams, selectedPligrams }) {

  const handleCheckboxChange = (pilgrim) => {
    const alreadySelected = selectedPligrams.some((p) => p.id === pilgrim.id);

    if (alreadySelected) {
      setSelectedPligrams(selectedPligrams.filter((p) => p.id !== pilgrim.id));
    } else {
      setSelectedPligrams([...selectedPligrams, pilgrim]);
    }
  };

  const handleSelectAll = () => {
    if (selectedPligrams.length === data.length) {
      setSelectedPligrams([]);
    } else {
      setSelectedPligrams(data);
    }
  };

  // ✅ Update contact number
  const handleContactChange = (id, value) => {
    setSelectedPligrams((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, contact: value } : p
      )
    );
  };

  // ✅ Auto-select leader(s)
  useEffect(() => {
    if (data?.length) {
      const leaders = data.filter((p) => p.leader === "1");
      if (leaders.length > 0) {
        setSelectedPligrams((prev) => {
          const newSelection = [...prev];
          leaders.forEach((leader) => {
            if (!newSelection.some((p) => p.id === leader.id)) {
              newSelection.push(leader);
            }
          });
          return newSelection;
        });
      }
    }
  }, [data, setSelectedPligrams]);

  return (
    <div>
      <div className="pt-4" style={{ marginTop: 5 }}>
        <h2 className="header-plagrims pb-2">{mainHeading}</h2>
        <hr />
      </div>

      <div className="mb-3 d-flex align-items-center">
        <p className="fw-bold mb-0">
          <input
            type="checkbox"
            className="me-2"
            checked={selectedPligrams.length === data.length}
            onChange={handleSelectAll}
          />
          Select all {data.length} pilgrims
        </p>
      </div>

      <div className="row gap-3">
        {data?.map((pilgrim) => {
          const isChecked = selectedPligrams.some((p) => p.id === pilgrim.id);
          const selectedPilgrim = selectedPligrams.find((p) => p.id === pilgrim.id);

          return (
            <div
              key={pilgrim.id}
              className="col-md-4"
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "15px",
                background: pilgrim.leader === "1"
                  ? "#d4edda" // ✅ green background for leader
                  : isChecked
                  ? "#f9f6ef"
                  : "#fff",
                boxShadow: "0px 2px 5px rgba(0,0,0,0.05)"
              }}
            >
              {/* Header with checkbox + name */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => handleCheckboxChange(pilgrim)}
                    className="me-2"
                  />
                  <span className="fw-bold">
                    {pilgrim.name}
                  </span>
                </label>
                <span className="badge bg-warning text-dark">{pilgrim.PilgrimType}</span>
              </div>

              {/* Info section */}
              <div className="mb-2">
                <div><strong>ID:</strong> {pilgrim.id}</div>
                <div><strong>Passport:</strong> {pilgrim.passport}</div>
                <div><strong>Age:</strong> {pilgrim.age}</div>
              </div>

              {/* Contact input */}
              <div className="input-group">
                <span className="input-group-text">#</span>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Contact Number"
                  value={selectedPilgrim?.contact || ""}   
                  onChange={(e) => handleContactChange(pilgrim.id, e.target.value)}  
                  disabled={!isChecked}
                   autoComplete="new-password"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SelectPligramComponents;
